import Alpine from 'alpinejs'
import SearchOverlay from ':/components/SearchOverlay'
import SlideMenu from ':/components/SlideMenu'
import Modal from ':/components/Modal'
import ModalBaseLineGSE from "../components/ModalBaseLineGSE";
import LightBox from ':/components/LightBox'
import LogoutModal from ':/components/LogoutModal'

Alpine.data('SearchOverlay', SearchOverlay)
Alpine.data('SlideMenu', SlideMenu)
Alpine.data('Modal', Modal)
Alpine.data('ModalBaseLineGSE', ModalBaseLineGSE)
Alpine.data('LightBox', LightBox)
Alpine.data('LogoutModal', LogoutModal)
